import { FC } from "react";
import { COLORS } from "shared/consts";

type BatteryIconProps = {
    fill?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
};

const BatteryIcon: FC<BatteryIconProps> = ({
    fill = COLORS.FG.DEFAULT,
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            className={className}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
        >
            <rect id="24 / Special / Battery 75%" width="20.000000" height="20.000000" x="0.000000" y="0.000000" />
            <path
                id="Union"
                d="M3.33268 5.8335C2.41221 5.8335 1.66602 6.57969 1.66602 7.50016L1.66602 12.5002C1.66602 13.4206 2.41221 14.1668 3.33268 14.1668L14.5827 14.1668C15.5032 14.1668 16.2493 13.4206 16.2493 12.5002L16.2493 7.50016C16.2493 6.57969 15.5032 5.8335 14.5827 5.8335L3.33268 5.8335ZM14.5827 7.0835L12.4993 7.0835C12.2692 7.0835 12.0827 7.27004 12.0827 7.50016L12.0827 12.5002C12.0827 12.7303 12.2692 12.9168 12.4993 12.9168L14.5827 12.9168C14.8128 12.9168 14.9993 12.7303 14.9993 12.5002L14.9993 7.50016C14.9993 7.27004 14.8128 7.0835 14.5827 7.0835ZM18.3166 8.3335L17.0666 8.3335L17.0666 11.6668L18.3166 11.6668L18.3166 8.3335Z"
                fill={fill}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default BatteryIcon;